import { createGetTextResources } from "../../utils/text-resources-algemeen";

export const getOnderpandTextResources = createGetTextResources({
  ErrorTaxatieDatum: "Vul de taxatiedatum in.",
  ErrorBouwjaar: "Vul het bouwjaar op deze manier in: jjjj. Bijvoorbeeld 2019.",
  ErrorOpleverdatum: "Vul een geldige datum in.",
  ErrorDatumTaxatieToekomst: "Vul een geldige datum in.",
  ErrorKadastraleNummer: "Het kadestrale nummer mag niet negatief zijn"
});
